export default "__VITE_ASSET__DDR7KyDK__"